import React from 'react'
import Constant from '../../Constant'
import WhyComponent from './WhyComponent'
import '../../../src/index.css'
import FadeInSection from '../FadeInSection'
import { motion } from 'framer-motion'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import PublicIcon from '@mui/icons-material/Public'
import GavelIcon from '@mui/icons-material/Gavel'
import GroupsIcon from '@mui/icons-material/Groups'

function Why() {
  return (
      <div className="fade-in p-6 bg-text-color1 sm:p-24">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="text-[24px] md:w-[80%] sm:text-[44px] mb-6 text-text-gray font-normal"
        >
          Why People <span className={Constant.linearColor}> Love Us</span>
        </motion.h1>

        <motion.div
          initial="hidden"
          whileInView="show"
          variants={{
            hidden: { opacity: 0, y: 50 },
            show: {
              opacity: 1,
              y: 0,
              transition: {
                staggerChildren: 0.2,
              },
            },
          }}
          viewport={{ once: true }}
          className="grid sm:grid-cols-2 gap-4 mb-4 md:grid-cols-3"
        >
          <motion.div variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}>
            <WhyComponent
              icon={<VolunteerActivismIcon fontSize="large" className="text-white" />}
              header="Values-Aligned Growth"
              content="At Halal Wealth, we provide carefully curated investment opportunities that adhere to Islamic principles, ensuring your financial success stays true to your values."
            />
          </motion.div>

          <motion.div variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}>
            <WhyComponent
              icon={<PublicIcon fontSize="large" className="text-white" />}
              header="Impact-Driven Investments"
              content="Your money goes beyond profits to support projects that drive positive social and environmental change, creating a lasting impact."
            />
          </motion.div>

          <motion.div variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}>
            <WhyComponent
              icon={<GavelIcon fontSize="large" className="text-white" />}
              header="Ethical Financial Solutions"
              content="From Shariah-compliant savings plans to interest-free asset financing, we offer tailored solutions that empower you to build wealth responsibly."
            />
          </motion.div>

          <motion.div variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}>
            <WhyComponent
              icon={<GroupsIcon fontSize="large" className="text-white" />}
              header="Circle"
              content="With Halal Wealth Circle, you don’t have to walk the journey alone. Pool resources with friends, family, or colleagues, and watch your plans come alive - secure, transparent, and halal."
            />
          </motion.div>
        </motion.div>
      </div>
  )
}

export default Why
